import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { useUIOnlyFeatureFlag } from "~/hooks/useUIOnlyFeatureFlag";
export function useIsProjectTenantVariablesEnabled(): boolean {
    const [isProjectTenantVariablesFeatureFlagEnabled] = useProjectTenantVariablesFeatureFlag();
    return isFeatureToggleEnabled("ProjectTenantVariablesFeatureToggle") && isProjectTenantVariablesFeatureFlagEnabled;
}
export function useProjectTenantVariablesFeatureFlag() {
    return useUIOnlyFeatureFlag("Project Tenant Variables", true);
}
